export default {
  viewType: Object.freeze({
    DAY_GRID_MONTH: 'dayGridMonth',
    TIME_GRID_WEEK: 'timeGridWeek',
    LIST_DAY_EXTENDED: 'listDayExtended',
  }),
}
